webpackJsonp([171289089103386],{

/***/ 438:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/suny/"},"frontmatter":{"title":"SUNY"}}}]}},"pathContext":{"tag":"SUNY"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-suny-7e01b1f76576b78dfa33.js